export const BORDER = "#f2c6cc";

export function normalizeList(res, keys = ["items", "data", "rows"]) {
  if (Array.isArray(res)) return res;
  for (const key of keys) {
    if (Array.isArray(res?.[key])) return res[key];
  }
  return [];
}

export function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString();
}

export function formatNumber(value) {
  const n = Number(value || 0);
  return Number.isFinite(n) ? n.toLocaleString() : "0";
}

export function toInputDate(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toISOString().slice(0, 10);
}

export function getReadableWarehouseOrderId(order) {
  const rawId = order?.orderCode || order?.order_code || order?.id || "";
  if (!rawId) return "-";

  const text = String(rawId).trim();

  if (text.startsWith("WO-")) return text;

  return `WO-${text.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
}